(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-new"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-alternate"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.js-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      // this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      // this.header.classList.add('shopify-section-header-sticky', 'animate');
      // this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      // this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.header.classList.remove('animate');

    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  // Three sections in this theme define a <sticky-header> element -- header,
  // header-alternate and header-v2 -- and only one of them ever renders on a
  // page. customElements.define() throws NotSupportedError on a duplicate tag
  // name, and Shopify wraps each section's compiled script in its own
  // try/catch, so a collision is swallowed and whichever definition happens to
  // be emitted first into compiled_assets/scripts.js silently wins. Today that
  // is header-alternate's copy, whose hide()/reveal() bodies are commented out
  // -- if it ever won the race the sticky header would simply stop working
  // with no error anywhere.
  //
  // Register only when this section's own wrapper is the one on the page, so
  // the definition can never come from a header that is not rendered. The
  // wrapper is present by the time this runs: the compiled bundle is deferred,
  // and header-v2's inline script sits below its own markup.
  if (document.getElementById('shopify-section-header-alternate') && !customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.js-section-header');

      // Pin the header for the whole page rather than running Dawn's
      // hide-on-scroll-down / reveal-on-scroll-up dance. "Enable sticky header"
      // is expected to mean the nav is always reachable; the stock behaviour
      // scrolls it away the moment you move down the page, which reads as the
      // setting not working at all.
      this.header.classList.add('shopify-section-header-sticky');

      this.setStickyOffset();

      // The offset depends on the rendered height of whatever is pinned above
      // the header, which is not fixed: the announcement bar wraps at narrow
      // widths and settles once late webfonts land.
      this.onResizeHandler = this.setStickyOffset.bind(this);
      window.addEventListener('resize', this.onResizeHandler, false);
      if (document.readyState !== 'complete') {
        window.addEventListener('load', this.onResizeHandler, { once: true });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResizeHandler);
    }

    setStickyOffset() {
      // Anything sticky above the header shares the same top:0 anchor and wins
      // on z-index -- the announcement bar pins itself with z-index 15 against
      // the header's 3 -- so it paints over the header's top edge and clips the
      // logo. Measure the pinned siblings and start the header below them.
      let offset = 0;
      let sibling = this.header.previousElementSibling;

      while (sibling) {
        const styles = window.getComputedStyle(sibling);

        // Only `sticky`, never `fixed`. Fixed siblings are out-of-flow overlays
        // that happen to sit above the header in source order -- the cart
        // drawer, the cookie-consent dialog -- and they neither push the header
        // down nor stay parked at the top of the viewport.
        if (styles.position === 'sticky' && styles.top !== 'auto' && parseFloat(styles.top) >= 0) {
          offset += sibling.getBoundingClientRect().height;
        }

        sibling = sibling.previousElementSibling;
      }

      this.header.style.setProperty('--sticky-header-top', offset + 'px');
    }
  }

  // Three sections in this theme define a <sticky-header> element -- header,
  // header-alternate and header-v2 -- and only one of them ever renders on a
  // page. customElements.define() throws NotSupportedError on a duplicate tag
  // name, and Shopify wraps each section's compiled script in its own
  // try/catch, so a collision is swallowed and whichever definition happens to
  // be emitted first into compiled_assets/scripts.js silently wins. Today that
  // is header-alternate's copy, whose hide()/reveal() bodies are commented out
  // -- if it ever won the race the sticky header would simply stop working
  // with no error anywhere.
  //
  // Register only when this section's own wrapper is the one on the page, so
  // the definition can never come from a header that is not rendered. The
  // wrapper is present by the time this runs: the compiled bundle is deferred,
  // and header-v2's inline script sits below its own markup.
  if (document.getElementById('shopify-section-header') && !customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
